import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { readVoiceQuoteSearch, voiceQuoteSearch } from './voiceQuoteLink';

export default function useVoiceQuoteState() {
  const location = useLocation();
  const navigate = useNavigate();
  const [options, setOptions] = useState(() => readVoiceQuoteSearch(location.search));
  useEffect(() => { setOptions(readVoiceQuoteSearch(location.search)); }, [location.pathname, location.search]);
  function updateOptions(next) {
    setOptions(next);
    let search;
    try { search = voiceQuoteSearch(next); } catch { return; }
    const params = new URLSearchParams(location.search);
    for (const [key, value] of new URLSearchParams(search)) params.set(key, value);
    navigate({ pathname: location.pathname, search: `?${params}`, hash: location.hash }, { replace: true, preventScrollReset: true });
  }
  let shareUrl = '';
  try { shareUrl = `${window.location.origin}${location.pathname}?${voiceQuoteSearch(options)}#application`; } catch { /* Incomplete inputs cannot be shared. */ }
  return { options, setOptions: updateOptions, shareUrl };
}
